import * as React from 'react';

import { createIcon } from '../Icon';
export const VideoOffIcon = createIcon(
  <React.Fragment>
    <path d="M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10" />
    <line x1={1} x2={23} y1={1} y2={23} />
  </React.Fragment>,
  'VideoOffIcon'
);
